export const MAX = 'max';
export const REQUIRED = 'required';
export const IS_UNIQUE = 'isUnique';
